import * as types from '../../mutation-types'
import axios from "axios";

export const login = async ({ commit, dispatch }, formData) => {
	await formData.post(process.env.API_URL + '/login').then(({data}) => {
		commit(types.SAVE_TOKEN, { token: data.token, remember: formData.remember })
		dispatch('fetchUser')
	});
}

export const register = async ({ commit, dispatch }, formData) => {
	const { data } = await formData.post(process.env.API_URL + '/register')
}

export const saveToken = ({ commit, dispatch }, payload) => {
	commit(types.SAVE_TOKEN, payload)
};

export const fetchUser = async ({ commit }) => {
	try {
	  const { data } = await axios.get(process.env.API_URL + '/user');
	  commit(types.FETCH_USER_SUCCESS, { user: data });
	  return data;
	} catch (e) {
	  commit(types.FETCH_USER_FAILURE);
	  throw e; 
	}
  };
  

export const updateUser =  async ({ commit }, formData) => {
	const { data } = await formData.patch(process.env.API_URL + '/settings/user')
	commit(types.UPDATE_USER, data)
};

export const updateProfile =  async ({ commit }, formData) => {
	let config = {
		headers: { 'content-type': 'multipart/form-data' }
	}
	axios.post(process.env.API_URL + '/settings/profile', formData, config)
		.then(function (response) {
			commit(types.UPDATE_USER, response.data)
		})
};

export const updatePassword = async ({ commit }, formData ) => {
	const { data } = await formData.patch(process.env.API_URL + '/settings/password')
	commit(types.UPDATE_USER, data)
};

export const logout = async ({ commit }) => {
	try {
		await axios.post(process.env.API_URL + '/logout')
	} catch (e) { }

	commit(types.LOGOUT)
};

export const fetchOauthUrl = async (ctx, provider) => {
	const { data } = await axios.post(process.env.API_URL + '/oauth/' + provider)
	return data
}

export const resendEmail = async ({ commit }, formData) => {
	const { data } = await formData.post(process.env.API_URL + '/email/resend')
	return data;
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js